export const REVENUE_CHALLENGE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfEe96utnyRKFVrFmezmPYpuo5WtZpEv8DWeAXfyB9hdV5EBA/viewform";
export const BUILDERS_CHALLENGE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSe9UY-wzh4pb0audMeIw_jjpsgfNWIitSFzUiRW34UlT1BtYg/viewform";
export const CHALLENGE_CONTACT_EMAIL = "build@spiritualdata.org";
